export default __webpack_public_path__ + "static/media/plus-icon.c9b5c48a.svg";